/**
 * The one text-field look (designer spec), shared by Input, Textarea, the Select trigger and
 * InputGroup so a form never mixes two field styles: 40 tall, 12px side padding, 8px corners
 * (`rounded-input`), 1px --surface-line border, white --surface-read fill, 13px --ink-body text,
 * --ink-meta placeholder. Error (`aria-invalid`) is a --status-bad border. Focus is the global
 * 2px accent outline (showcase-bridge.css) and disabled is 50% opacity, so neither is set here.
 * Height is added per control: a textarea is `min-h-*` only.
 */
export const FIELD_LOOK =
  "w-full min-w-0 rounded-input border border-[var(--surface-line)] bg-[var(--surface-read)] px-3 text-sm " +
  "text-[var(--ink-body)] placeholder:text-[var(--ink-meta)] transition-colors " +
  "disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-[var(--status-bad)]"
